// Chakra imports
import { Portal, Box, useDisclosure } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import masterRoute from 'routes.js';

export default function Dashboard(props) {
  const { ...rest } = props;
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const getRoute = () => {
    return window.location.pathname !== '/master/full-screen-maps';
  };
  const getActiveRoute = (masterRoute) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < masterRoute.length; i++) {
      if (masterRoute[i].collapse) {
        let collapseActiveRoute = getActiveRoute(masterRoute[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (masterRoute[i].category) {
        let categoryActiveRoute = getActiveRoute(masterRoute[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(masterRoute[i].layout + masterRoute[i].path) !== -1
        ) {
          return masterRoute[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (masterRoute) => {
    let activeNavbar = false;
    for (let i = 0; i < masterRoute.length; i++) {
      if (masterRoute[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(masterRoute[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (masterRoute[i].category) {
        let categoryActiveNavbar = getActiveNavbar(masterRoute[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(masterRoute[i].layout + masterRoute[i].path) !== -1
        ) {
          return masterRoute[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (masterRoute) => {
    let activeNavbar = false;
    for (let i = 0; i < masterRoute.length; i++) {
      if (masterRoute[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(masterRoute[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (masterRoute[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(masterRoute[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(masterRoute[i].layout + masterRoute[i].path) !== -1
        ) {
          return masterRoute[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.children && route.children.length > 0) {
        return (
          <>
          {route.children.map((childRoute, childKey) => (
            <Route
              path={childRoute.path}
              element={childRoute.component}
              key={childKey}
            />
          ))}
        </>
        );
      }
  
      return (
        <Route
          path={route.path}
          element={route.component}
          key={key}
        />
      );
    });
  };
  document.documentElement.dir = 'ltr';
  const { onOpen } = useDisclosure();
  document.documentElement.dir = 'ltr';
  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar masterRoute={masterRoute} display="none" {...rest} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={'Horizon UI Dashboard PRO'}
                  brandText={getActiveRoute(masterRoute)}
                  secondary={getActiveNavbar(masterRoute)}
                  message={getActiveNavbarText(masterRoute)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx="auto"
                p={{ base: '20px', md: '30px' }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                <Routes>
                  {getRoutes(masterRoute)}
                  <Route
                    path="/"
                    element={<Navigate to="/master/materDashboard" replace />}
                  />
                </Routes>
              </Box>
            ) : null}
            <Box>
              <Footer />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
